import '@backstage/cli/asset-types';
// Must be evaluated before anything that imports @mui/material — see the
// module for what breaks otherwise. Keep it above the imports below.
import './muiClassNamePrefix';
// Backstage UI's global stylesheet. @backstage/theme 0.7.0 dropped the built-in
// CssBaseline from UnifiedThemeProvider and moved the global styles here, and
// since @backstage/plugin-catalog 2.0.0 the About/Links/profile cards render as
// BUI components. Without this import they still get their bui-* class names
// but no rules to go with them, so they lose all card chrome and layout.
import '@backstage/ui/css/styles.css';
import './bui-theme.css';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
